//import "./ladzo.less";

import "./ladzo.scss";
import "bootstrap";

import { LadzoConsole as Lc } from "./js/global/ladzo-console.js";
import { Top } from "./js/class/Top.js";
import { MojeFce as Fce } from "./js/global/fce.js";
import * as cookie from "./js/incl/cookie_lista.js";
//import * as mapa from "./js/incl/mapa.js";
import * as mapaApp from "./js/incl/mapaApp.js";
//import { autocompleteStitku } from "./js/incl/autocompleteStitku.js";
import * as stitkyMistMultiselect from "./js/incl/stitkyMistMultiselect.js";
//import * as scroll from "./js/incl/scrollWatcher.js";

import * as testMapa from "./test-app/test-mapa.js";

Top.nodeServer = window.ladzoNodeServer || false;

var Url = new URL(window.location.href);
Top.localhost = false;

let debug = Fce.get(window, "debug") || false;

if (
  process.env.NODE_ENV == "development" ||
  Url.searchParams.has("debug") ||
  debug
) {
  Lc.zobraz({ version: "1.0.0.004.1", appName: "mapa.ladzo.cz" });
}
if (process.env.NODE_ENV == "development") {
  Top.localhost = true;
  Top.filtrySkladem = true;

  let b = Fce.get(window, "Ladzo.localhost") || false;
  if (!b) Top.localhost = false;
}
window.addEventListener("load", function () {
  cookie.zobrazCookieListu();
  //nn(2);
});

$(function () {
  //nav.zobrazNavigaci();

  let Dl = Fce.getDataLayer();
  Top.DataLayer = Dl;
  Lc.log("Dl", Dl);

  let bodyItr = $("body").attr("id");

  if (bodyItr == "bdUvod") {
    mapa.zobrazMapu();
    //uprava pro carousel
    /*
    $("#dvCarousel").on("init", function (event, slick) {
      $(this).removeClass("non");
    });
    */
  } else if (bodyItr == "bdMapa") {
    mapaApp.zobrazMapu();
  } else if (bodyItr == "bdMMisto") {
    //autocompleteStitku.zobraz();
    stitkyMistMultiselect.zobraz();
    //stitkyMistMultiselect.mount();
  } else if (bodyItr == "bdTest") {
    Lc.f("bdTest");
    testMapa.zobrazMapu();
    //autocompleteStitku.zobraz();

    //stitkyMistMultiselect.mount();
  }

  //$("html").addClass("htmlNavig");

  /*
  scroll.watchScrollFix("#aMenu", {
    offset: 50, // třeba 50px
    className: "fixed", // třída co se přidá
  });
  */
});
